import Axios from "axios";
import React, { useState, useEffect } from "react";
import url from "../../../services/url";

function Location({ data }) {
  const [element, setElement] = useState({
    type: "location",
    properties: {
      label: "State and City",
      options: [],
      cities: [],
      required: true,
    },
  });

  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  useEffect(() => {
    setElement(data);
    setState(data.properties.options[0]);
  }, [data]);

  useEffect(() => {
    if (state !== "") {
      Axios.post(url("cities"), { state },{
        headers:{
          Authorization: `Bearer ${localStorage.getItem("user.token")}`
        }})
        .then((result) => {
          setElement((prev) => {
            return {
              type: prev.type,
              properties: {
                label: prev.properties.label,
                options: prev.properties.options,
                cities: result.data,
              },
              multiple: prev.multiple,
              required: prev.required,
            };
          });

          setCity(result.data[0]);
        })
        .catch(console.error);
    }
  }, [state]);

  const onChangeStateSelect = (event) => {
    setState(event.target.value);
  };

  function onChangeCitySelect(event) {
    setCity(event.target.value);
  }

  return (
    <div className="form-builder-element mb-3">
      <div className="row">
        <div className="col-md-6">
          <label htmlFor="">State*</label>

          <select className="form-control" onChange={onChangeStateSelect}>
            {element.properties.options.map((v, k) => (
              <option value={v} key={k}>
                {v}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <label htmlFor="">City*</label>

            <select className="form-control">
              {element.properties.cities.map((v, k) => (
                <option value={v} key={k} onChange={onChangeCitySelect}>
                  {v}
                </option>
              ))}
            </select>
          </div>
        </div>

        <input
          type="hidden"
          className="form-view"
          label={element.properties.label}
          data={JSON.stringify(element)}
          value={city + ", " + state}
        />
      </div>
    </div>
  );
}

export default Location;
